export default class Notification {
  constructor(data) {
    this.id = data.id || null; 
    this.user_id = data.user_id;
    this.from_user_id = data.from_user_id || null;
    this.notification = data.notification || "";
    this.type = data.type || "generic";
    this.is_read = data.is_read ?? false;
    this.created_at = data.created_at
      ? new Date(data.created_at._seconds * 1000)
      : new Date();
  }
}